import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress benign "ResizeObserver loop completed with undelivered notifications" error.
// This is a browser-level timing issue (not an app bug) that triggers React's dev error overlay
// when dropdowns/selects resize on close. Safe to ignore per the ResizeObserver spec.
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);
